import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { InstructorViewModel, PaperSubmissionSummaryViewModel } from 'src/app/_models/generatedModels';
import { AdminCallForPapersService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-presenter-details',
  templateUrl: 'presenter-details.component.html',
})
export class PresenterDetailsComponent implements OnInit {
  initialized = false;
  @Input()
  user: InstructorViewModel;

  @Input()
  conferenceId: number;

  @Input()
  organizationId: number;

  @Input()
  route: ActivatedRoute;

  @Input()
  paperId: number;


  otherPapers: PaperSubmissionSummaryViewModel[];
  constructor(public activeModal: NgbActiveModal, private adminCFP: AdminCallForPapersService) {}

  ngOnInit(): void {
    console.log(this.route.url);
    this.adminCFP.getOtherSubmissionsForPresenter(this.organizationId.toString(), this.conferenceId, this.user.id).subscribe((result) => {
      this.otherPapers = Enumerable.from(result).where((x) => x.id != this.paperId).toArray();
      this.initialized = true;
    });
  }

  onCancel() {
    this.activeModal.dismiss();
  }
}
